import React from 'react'
import {connect} from 'react-redux'
import {withStyles} from '@material-ui/core/styles'
import Dialog from '@material-ui/core/Dialog'
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import CloudDoneIcon from '@material-ui/icons/CloudDone'
import {getList} from '../../src/pages/home/routes/notice/reducers/list'
import DateFormat from '../util/dateFormat'
import _ from 'lodash'

const storage = window.localStorage;
const update_flag = "update_flag"
const styles = theme => ({
    contentContainer: {
        paddingLeft: theme.spacing.unit * 3,
    },
    listIcon: {
        color: '#4051b5',
        marginRight: theme.spacing.unit
    },
    titleIcon: {
        marginRight: theme.spacing.unit
    },
    expandTitle: {
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
        alignItems: 'center'
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        fontWeight: theme.typography.fontWeightRegular,
        display: 'flex',
        alignItems: 'center',
    },
})
class UpdateDes extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            updateFlag: !storage.getItem(update_flag),
            expanded: 0
        }
    }
    componentDidMount() {
        const { dispatch } = this.props
        dispatch(getList())
    }
    handleClose = () => {
        this.setState({ updateFlag: false })
    }
    componentDidUpdate() {
        const {noticeList} = this.props
        if (noticeList && noticeList.length > 0 && noticeList[0].createTime > storage.getItem(update_flag)) {
            storage.setItem(update_flag,noticeList[0].createTime)
            this.setState({updateFlag: true })
        }
    }
    handleChange = index => (event, expanded) => {
        this.setState({
          expanded: expanded ? index : false,
        });
    };
    render() {
        const { updateFlag,expanded } = this.state
        const {classes,noticeList} = this.props
        return (
            <div>
                {noticeList && <Dialog
                    open={Boolean(updateFlag) && noticeList.length>0}
                    onClose={() => this.handleClose()}
                    fullWidth
                >
                    {/* <DialogTitle>更新公告</DialogTitle> */}
                    {_.slice(noticeList,0,3).map((item,index) => {
                        return   <ExpansionPanel key={index} expanded={expanded === index} onChange={this.handleChange(index)}>
                                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                                        <div className={classes.expandTitle}>
                                            <Typography className={classes.heading}><CloudDoneIcon color="primary" className={classes.titleIcon} />{item.title}</Typography>
                                            <Typography variant="caption">{DateFormat(new Date(item.createTime),'yyyy-MM-dd')}</Typography>
                                        </div>
                                    </ExpansionPanelSummary>
                                    <ExpansionPanelDetails>
                                        <Typography component="div" className={classes.contentContainer}>
                                            {item.content.split('\n').map((ii,index)=>{
                                                return (<div key={index}><span className={classes.listIcon}>&#9670;</span>{ii}</div>)
                                            })}
                                        </Typography>
                                    </ExpansionPanelDetails>
                                </ExpansionPanel>
                    })}
                    {/* <DialogActions>
                        <Button variant="outlined" color="primary" onClick={() => this.handleClose()}>确定</Button>
                    </DialogActions> */}
                </Dialog>}
            </div>
        )
    }
}


export default connect(({notice}) => ({noticeList: notice.list}))(withStyles(styles)(UpdateDes))


// WEBPACK FOOTER //
// ./src/uis/updateDes.js